import { render, staticRenderFns } from "./ModalGoToSetting.vue?vue&type=template&id=49ab1dbb&scoped=true"
import script from "./ModalGoToSetting.vue?vue&type=script&lang=js"
export * from "./ModalGoToSetting.vue?vue&type=script&lang=js"
import style0 from "./ModalGoToSetting.vue?vue&type=style&index=0&id=49ab1dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab1dbb",
  null
  
)

export default component.exports